import React, { useState } from 'react';
import styles from './style.module.less';
import { getFileTypeFromUrl } from './utils';

export default ({ urls, itemWidth }) => {
  const [activeUrl, setActiveUrl] = useState(null);

  const handleMediaClick = (url) => {
    setActiveUrl(url);
  };

  const handleClosePreview = () => {
    setActiveUrl(null);
  };

  return (
    <div className={styles.gallery}>
      {urls.map((url, index) => {
        return (
          <div
            key={index}
            className={styles.galleryItem}
            style={{ width: itemWidth }}
          >
            {getFileTypeFromUrl(url) === 'image' && (
              <img src={url} onClick={() => handleMediaClick(url)} />
            )}
            {getFileTypeFromUrl(url) === 'video' && (
              <video controls width="200" src={url}></video>
            )}
          </div>
        );
      })}

      {activeUrl !== null && (
        <div className={styles.previewOverlay} onClick={handleClosePreview}>
          <div className={styles.previewContent}>
            <img src={activeUrl} width="80%" />
          </div>
        </div>
      )}
    </div>
  );
};
